import { fetchCroppedImage } from '@/utils/constants';
import { ColorPicker } from 'primereact/colorpicker';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { toast } from 'react-toastify';
import { ImageType } from '@/services/openai.service';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import {
  priorityicon1,
  priorityicon10,
  priorityicon11,
  priorityicon12,
  priorityicon13,
  priorityicon14,
  priorityicon15,
  priorityicon16,
  priorityicon17,
  priorityicon2,
  priorityicon3,
  priorityicon4,
  priorityicon5,
  priorityicon6,
  priorityicon7,
  priorityicon8,
  priorityicon9,
  trustimg1,
  trustimg2,
  trustimg3,
  trustimg4,
} from '@/utils/imagepath';

const AboutUsEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const section8 = editData?.theme_3?.home?.section_8;
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [showCropModalTwo, setShowCropModalTwo] = useState<boolean>(false);

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [imageImages, setImageImages] = useState<string[]>([]);
  const [iconImages, setIconImages] = useState<string[]>([]);

  const bannerImages: Array<string> = [
    trustimg1,
    trustimg3,
    trustimg4,
    trustimg2,
    trustimg1,
    trustimg3,
    trustimg4,
    trustimg2,
  ];
  const icons = [
    priorityicon1,
    priorityicon2,
    priorityicon3,
    priorityicon4,
    priorityicon5,
    priorityicon6,
    priorityicon7,
    priorityicon8,
    priorityicon9,
    priorityicon10,
    priorityicon11,
    priorityicon12,
    priorityicon13,
    priorityicon14,
    priorityicon15,
    priorityicon16,
    priorityicon17,
  ];
  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_3.home.section_8.card_section.collection,
    ];
    if (index != undefined) {
      updatedCollection = [
        ...editData.theme_3.home.section_8.card_section.collection,
      ];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        home: {
          ...prevJsonData.theme_3.home,
          section_8: {
            ...prevJsonData.theme_3.home.section_8,
            [name]: value,
            btn_group: {
              ...prevJsonData.theme_3.home.section_8.btn_group,
              [name]: value,
            },
            card_section: {
              ...prevJsonData.theme_3.home.section_8.card_section,
              ...prevJsonData.theme_3.home.section_8.card_section.collection[
                index
              ],
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const handleBannerImageChange = (image: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        home: {
          ...prevJsonData.theme_3.home,
          section_8: {
            ...prevJsonData.theme_3.home.section_8,
            section_image: image,
            card_section: {
              collection: [
                ...editData.theme_3.home.section_8.card_section.collection,
              ],
            },
            btn_group: {
              ...prevJsonData.theme_3.home.section_8.btn_group,
            },
          },
        },
      },
    }));
  };
  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleBannerImageChange(imageLink);
    }
  };
  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };
  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_3.home.section_8.card_section.collection,
    ];
    updatedCollection.splice(index, 1);
    setActiveTab(activeTab - 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        home: {
          ...prevJsonData.theme_3.home,
          section_8: {
            ...prevJsonData.theme_3.home.section_8,
            card_section: {
              btn_group: {
                ...prevJsonData.theme_3.home.section_8.card_section.btn_group,
              },
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [
      ...editData.theme_3.home.section_8.card_section.collection,
    ];
    updatedCollection[index] = {
      ...updatedCollection[index],
      collection_image: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        home: {
          ...prevJsonData.theme_3.home,
          section_8: {
            ...prevJsonData.theme_3.home.section_8,
            card_section: {
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  const updateImageSectionTwo = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModalTwo(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImageTwo(res.target.result);
      };
    }
  };
  const handleCroppedImageTwo = async (image: any) => {
    setShowCropModalTwo(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };
  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_3.home.section_8.card_section.collection,
    ];

    let newCard = {
      collection_title: '',
      collection_image: 'assets/icons/priorityicon1.png',
      isEnabled: true,
      collection_paragraph: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        home: {
          ...prevJsonData.theme_3.home,
          section_8: {
            ...prevJsonData.theme_3.home.section_8,
            card_section: {
              btn_group: {
                ...prevJsonData.theme_3.home.section_8.card_section.btn_group,
              },
              collection: updatedCollection,
            },
          },
        },
      },
    }));
  };
  // Auto-generate prompt based on about us section context for Banner
  const generateAutoPromptBanner = (): string => {
    const title = editData?.theme_3?.home?.section_8?.title || '';
    const paragraph = editData?.theme_3?.home?.section_8?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional image for website about us section';
    
    if (title || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add about us-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for about us section, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI banner image save
  const handleAIImageSaveBanner = (imageUrl: string) => {
    // Set the banner image
    handleBannerImageChange(imageUrl);
    
    // Add to image images array for slider
    setImageImages(prevImages => [...prevImages, imageUrl]);
  };

  // Auto-generate prompt based on current card context for icon
  const generateAutoPromptIcon = (): string => {
    // Get context from the current active card
    const currentCard = editData?.theme_3?.home?.section_8?.card_section?.collection?.[activeTab];
    const cardTitle = currentCard?.collection_title || '';
    const cardParagraph = currentCard?.collection_paragraph || '';
    const sectionTitle = editData?.theme_3?.home?.section_8?.title || '';
    const sectionParagraph = editData?.theme_3?.home?.section_8?.paragraph || '';
    
    // Build context-based prompt for icon
    let contextPrompt = 'modern minimalist icon design';
    
    if (cardTitle || cardParagraph || sectionTitle || sectionParagraph) {
      const contextParts: string[] = [];
      if (sectionTitle) contextParts.push(`section: "${sectionTitle}"`);
      if (cardParagraph) {
        // Extract keywords from paragraph
        const keywords = cardParagraph.split(' ').slice(0, 3).join(' ');
      } else if (sectionParagraph) {
        const keywords = sectionParagraph.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add icon-specific styling
    contextPrompt += ', clean modern minimalist icon, professional design, suitable for card icon, vibrant colors, high quality, simple and recognizable, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    // Auto-apply the icon to the current active card
    handleImageChange(iconUrl, activeTab);
    
    // Add to icons array for slider
    setIconImages(prevIcons => [...prevIcons, iconUrl]);
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template3';
      const currentTemplate = templateImages[templateKey];
      
      // Load images for main banner
      const imageImgs = currentTemplate?.image || [];
      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              resolve({ url, width: img.width, height: img.height });
            };
            img.onerror = () => {
              resolve(null);
            };
            img.src = url;
          });
        };

        const filterImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for square/icon images (aspect ratio 0.9-1.1)
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setImageImages(squareImages);
        };

        filterImages();
      } else {
        setImageImages([]);
      }

      // Load icons for card section
      const iconImgs = currentTemplate?.icon || [];
      if (Array.isArray(iconImgs) && iconImgs.length > 0) {
        const loadIconDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              resolve({ url, width: img.width, height: img.height });
            };
            img.onerror = () => {
              resolve(null);
            };
            img.src = url;
          });
        };

        const filterIcons = async () => {
          const iconPromises = iconImgs.map((img: any) => loadIconDimensions(img.url));
          const loadedIcons = await Promise.all(iconPromises);
          
          // Filter for square/icon images (aspect ratio 0.9-1.1)
          const squareIcons = loadedIcons
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setIconImages(squareIcons);
        };

        filterIcons();
      } else {
        setIconImages([]);
      }
    } else {
      setImageImages([]);
      setIconImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      {' '}
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section8 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={section8?.title}
                      onChange={(e) => {
                        if (e.target.value.length < 251) {
                          handleChange(e);
                        }
                      }}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Paragraph
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleChange({
                            target: {
                              name: 'paragraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="about_us"
                        placeholder="Describe what you want in your paragraph. Example: 'Write about our company and mission'"
                        context="This is for an about us section paragraph"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph"
                      value={section8?.paragraph}
                      onChange={(e) => {
                        if (e.target.value.length < 1200) {
                          handleChange(e);
                        }
                      }}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_3?.home?.section_8?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_3?.home?.section_8?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 2 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_3?.home?.section_8?.h3color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_3?.home?.section_8?.h3color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_3?.home?.section_8?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_3?.home?.section_8?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="img-bg active">
                          <img src={section8?.section_image} alt="Hero Image" />
                        </div>
                        <div className="img-options w-100">
                          {imageImages.length > 0 ? (
                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: {
                                  slidesPerView: 1,
                                },
                                768: {
                                  slidesPerView: 4,
                                },
                                1024: {
                                  slidesPerView: 6,
                                },
                              }}
                              className="homejson-slider"
                            >
                              {imageImages.map((imageUrl: string, imgIndex: number) => (
                                <SwiperSlide key={imgIndex}>
                                  <div
                                    className="img-option"
                                    onClick={() => handleBannerImageChange(imageUrl)}
                                  >
                                    <img
                                      src={imageUrl}
                                      alt="AI Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          ) : (
                            <div className="empty-slider-state text-center py-4">
                              <div className="empty-state-content">
                                <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                <h6 className="text-muted mb-2">No Images Available</h6>
                                <p className="text-muted small mb-3">
                                  Generate AI images or upload your own to see them here
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Image Generator */}
              <AIImageGenerator
                generateAutoPrompt={generateAutoPromptBanner}
                onSave={handleAIImageSaveBanner}
                imageType="image"
                defaultWidth="1024"
                defaultHeight="1024"
                title="AI Image"
                autoGenerate={true}
                template={template}
              />

              <div className="mb-3">
                <label className="form-label">Upload Image</label>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  className="form-control"
                  name="image"
                  onChange={updateImageSectionOne}
                />
              </div>
            </div>
            {/* <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button 1</label>
                    <input
                      type="text"
                      className="form-control"
                      name="btn1_text"
                      value={section8?.btn_group?.btn1_text}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Bg Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btn1_bg_color"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn1_bg_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="btn1_bg_color"
                        onChange={(e) => {
                          handleChange(e);
                          saveJsonDataToFile();
                        }}
                        format="hex"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn1_bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btn1_color"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn1_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="btn1_color"
                        onChange={(e) => {
                          handleChange(e);
                          saveJsonDataToFile();
                        }}
                        format="hex"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn1_color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button 2</label>
                    <input
                      type="text"
                      className="form-control"
                      name="btn2_text"
                      value={section8?.btn_group?.btn2_text}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Bg Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btn2_bg_color"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn2_bg_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="btn2_bg_color"
                        onChange={(e) => {
                          handleChange(e);
                          saveJsonDataToFile();
                        }}
                        format="hex"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn2_bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btn2_color"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn2_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="btn2_color"
                        onChange={(e) => {
                          handleChange(e);
                          saveJsonDataToFile();
                        }}
                        format="hex"
                        value={
                          editData?.theme_3?.home?.section_8?.btn_group
                            ?.btn2_color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_3?.home?.section_8?.card_section?.collection.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_3?.home?.section_8?.card_section?.collection.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.collection_image}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            {iconImages.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {iconImages.map((iconUrl: string, iconIndex: number) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() =>
                                        handleImageChange(iconUrl, index)
                                      }
                                    >
                                      <img
                                        src={iconUrl}
                                        alt="AI Icon"
                                        className="img-fluid"
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Icons Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI icons or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* AI Icon Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />

                      <div className="mb-3">
                        <label className="form-label">Upload Icon</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSectionTwo}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_title"
                          value={card.collection_title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">
                            Paragraph
                          </label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleChange({
                                target: {
                                  name: 'collection_paragraph',
                                  value: content,
                                },
                              }, index);
                            }}
                            contentType="product_description"
                            placeholder="Describe this point. Example: 'Write about our commitment to quality'"
                            context="This is for an about us card description 1 liner or 10 words"
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_paragraph"
                          value={card.collection_paragraph}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
      {showCropModalTwo ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImageTwo}
              close={() => {
                setShowCropModalTwo(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default AboutUsEditModal;
